import React, { useEffect, useState } from 'react'
import "./pendingActionsCard.css"
import ApiAgTable from '../ag-table/api_ag-table'
import Utils from '../../util/Utils'
import { useGlobalState } from '../../GlobalState'

export default function PendingActionsCard({ erpData }) {
       let { menuList, changeCurrentMenu } = useGlobalState()

    const [ myActionData ,setMyActionData ] = useState([])
    const [ loading , setLoading] = useState(false)

        // useEffect(async () => {
        //     try {
        //        let results = await ApiAgTable.myactionsData(0, 1000, "", "", {
        //             actionType
        //                 :
        //                 "CUSTOMER",
        //             displayStatus
        //                 :
        //                 "PENDING"
        //         }).then(res =>{ 
        //           res.clone().json().then((res) => {
        //             console.log('olpoijhh' , res );                    
        //             setMyActionData(res.results)
        //         }, err => {
        //             console.log(err)
        //         })
        //         }).catch((e)=>
        //           console.log(e)                  
        //         ) 
            
        //     } catch (e) {
        //       throw new Error(`API error:${e?.message}`)             
        //     }
        // }, [])
        // const abortController = new AbortController();
        useEffect ( ()=> {
          let results =  ApiAgTable.myactionsDataDashBd(0, 1000, "", "", {}).then(res=>{
                          res.clone().json().then((res) => { 
                            // let status = ['Invoice Acceptance (Credit)', 'Invoice Acceptance & Payment Details (COD)', 'Invoice Acceptance'  ]
                            // let filteredRes = res.results.filter((x)=> status.includes( x.Myactions.actionName) )    
                            setMyActionData(res.results)                        
                              setLoading(false)
                          }, err => {
                          setLoading(false)                  
                              console.log(err)
                          })
                      }).catch((e)=>{
                          if(e.name==="AbortError"){
                              setLoading(true)
                          }else{
                              setLoading(false)
                          } 
                      })
        }, [])

       const changeMenuComponent = (r) => {
        if(r === 'My Actions'){
        let menus = menuList.filter(x => x.name == 'Cross-Border')       
        changeCurrentMenu(menus[0].children[6].key)
        }else if (r === 'Approvals') {
          let menus = menuList.filter(x => x.key === 'Approvals')       
          changeCurrentMenu(menus[0].key)
        }
       }

        // console.log('kiuhnj', erpData , myActionData );

        
        

  return (
    <div style={{ backgroundColor : "white" , padding : "1% 2%" , borderRadius : "5px" }}>
          <div className='is-flex'>
          <h4 className='is-size-5 wd_100' >Pending Actions</h4>  
          <button style = {{ padding: "0%  0.5%" , borderRadius : "20px" , backgroundColor : "#FFF1E4" , border : "1px solid #E87A1A" , color : "#E87A1A" , marginRight : '1%' , cursor: "pointer"   }} onClick={()=>changeMenuComponent('My Actions') }  >
        Pending My Actions : 15
       </button> 
       <button style = {{ padding: "0%  0.5%" , borderRadius : "20px" , backgroundColor : "#FFE9E9" , border : "1px solid #ED4545" , color : "#ED4545"  }} onClick={()=>changeMenuComponent('Approvals') }  >
        Pending Approvals : 12
       </button> 
          </div>
          <div>
          <table className='penActionsDashTable' style={{ width: "100%", borderCollapse: "collapse" }}  >
        
            <thead>
                <th style={{ width: "15%" }}>Booking Id</th>
                <th style={{ width: "10%" }}>Sub Job</th>
                <th style={{ width: "15%" }}>HBL/MBL</th>
                <th style={{ width: "10%" }}>Invoice Number</th>
                <th style={{ width: "10%" }}>Invoice Date</th>
                <th style={{ width: "20%" }}>Action</th>
                <th style={{ width: "8%" }}>Invoice Type</th>
                <th style={{ width: "8%" }}>Currency Outstanding</th>
                <th style={{ width: "10%" }}>Ageing</th>
            </thead>
            </table>
             <div style={{maxHeight : "200px" , overflowY : 'scroll' ,overflowX: 'scroll' ,minWidth : "100%" }}>  
             <table style={{ width: "100%", borderCollapse: "collapse" }}>        
             <tbody >
                         {
                  myActionData?.map((r,i) => 
                   { let erpobj =  erpData?.filter((x)=>x.bookingNum === r._id.bookingNum )[0]
                    return  <tr>
                        <td style={{ width: "15%" }}>
                           {r._id.bookingNum} 
                        </td>
                        <td style={{ width: "10%" }}>{erpobj?.SUBJOB_NO}</td>
                        <td style={{ width: "15%" }}>{erpobj?.HOUSE_NO}</td>
                        <td style={{ width: "10%" }}>{erpobj?.DOCUMENT_NO}</td>
                        <td style={{ width: "10%" }}>{erpobj?.DOCUMENT_DATE}</td>
                        <td style={{ width: "20%" }}>{r.Myactions.actionName}</td>
                        <td style={{ width: "8%" }}>Bill</td>
                        <td style={{ width: "8%" }}>{r.Myactions?.totalAmount}</td>
                        <td style={{ width: "10%" }}>{ erpobj ? Utils.docAgeing(erpobj ) : ''}</td>
                        </tr>
                   }
                   )
                }
             </tbody>
             </table>
             </div>
        
          </div>
    </div>
  )
}


